<script setup lang="ts">
import AppBar from "~/components/App/AppBar.vue"
import NavDrawer from "~/components/App/NavDrawer.vue"
</script>

<template>
  <div>
    <AppBar />
    <NavDrawer />
    <v-main class="px-4 my-4">
      <slot />
    </v-main>
  </div>
</template>
